import { gql } from '@apollo/client'

export const OPERATION_SITE_SET_VISIBILITY_IN_CENTER = gql`
  mutation SiteSetVisibilityInCenter($id: ID!, $visibility: String!) {
    site: siteSetVisibilityInCenter(id: $id, visibility: $visibility) {
      id
      visibility_in_center
    }
  }
`

export const OPERATION_SITE_UPDATE_VISIBILITY_BY_IDS = gql`
  mutation SiteUpdateVisibilityByIds($ids: [ID!]!, $visibility: String!) {
    count: siteUpdateVisibilityByIds(ids: $ids, visibility: $visibility)
  }
`

export const OPERATION_SITE_UPDATE_VISIBILITY_BY_QUERY = gql`
  mutation SiteUpdateVisibilityByQuery(
    $visibility: String!
    $verbatim: String
    $state: [String]
    $has_active_project: Boolean
    $has_process: Boolean
    $visibility_in_center: String
    $sf_parent_id: String
  ) {
    count: siteUpdateVisibilityByQuery(
      visibility: $visibility
      verbatim: $verbatim
      state: $state
      has_active_project: $has_active_project
      has_process: $has_process
      visibility_in_center: $visibility_in_center
      sf_parent_id: $sf_parent_id
    )
  }
`

export const OPERATION_SITE_SYNC_PROJECT_FIELDS = gql`
  mutation SiteSyncProjectFields($id: ID!) {
    site: siteSyncProjectFields(id: $id) {
      id
      state
      has_active_project
      has_process
      visibility_in_center
    }
  }
`
